import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-google-button',
  imports: [TranslatePipe],
  templateUrl: './google-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './google-button.component.scss'
})
export class GoogleButtonComponent {

}
